import React, { ReactElement } from 'react';
import { FieldProps, ErrorMessage, useFormikContext, getIn } from 'formik';
import classnames from 'classnames';
import { tile } from '@interfaces/interfaces';
import styles from './CheckboxInputGroup.module.scss';

interface iProps extends FieldProps {
  title: string;
  tileData: tile[];
  disabled?: boolean;
  displayError?: boolean;
}

const CheckboxInputGroup = ({ field, form, tileData, title, disabled = false, displayError = true }: iProps): ReactElement => {
  const { values, errors }: { values: any; errors: any } = useFormikContext();
  const hasError = getIn(errors, field.name);

  return (
    <div>
      <span>{title}</span>
      {tileData.map((tileItem) => (
        <React.Fragment key={tileItem.value}>
          <label className={styles.container} htmlFor={tileItem.value}>
            <input
              type="checkbox"
              className={classnames({
                [styles.inputError]: hasError,
              })}
              id={tileItem.value}
              name={field.name}
              value={tileItem.value}
              onChange={(e) => {
                if (e.target.checked) {
                  form.setFieldValue(field.name, [...getIn(values, field.name), e.target.value]);
                } else {
                  form.setFieldValue(
                    field.name,
                    getIn(values, field.name).filter((checkedInputs: string) => checkedInputs !== e.target.value),
                  );
                }
              }}
              checked={getIn(values, field.name).includes(tileItem.value)}
              disabled={disabled}
            />
            <span className={styles.tickContainer} />
            <span className={styles.body}>{tileItem.body}</span>
          </label>
          <hr />
        </React.Fragment>
      ))}
      {displayError && <ErrorMessage className={styles.errorMsg} name={field.name} component="span" />}
    </div>
  );
};

export default CheckboxInputGroup;
